import { api } from "@/service";
import type { TTransaction } from "@/types";
import { AxiosError } from "axios";

export interface TransactionQuery {
   page?: number;
   limit?: number;
   memberId?: string;
}

export class TransactionService {
   private static instance: TransactionService;

   static getInstance() {
      if (TransactionService.instance) {
         return TransactionService.instance;
      }
      TransactionService.instance = new TransactionService();
      return TransactionService.instance;
   }
   async getTransactions(slug: string, query?: TransactionQuery) {
      return api
         .get<TTransaction[]>(`/workspaces/${slug}/transactions/`, {
            params: query,
         })
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
   async getTransaction(slug: string, id: number | string) {
      return api
         .get<TTransaction>(`/workspaces/${slug}/transactions/${id}`)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
   async updateTransaction(
      slug: string,
      id: number,
      data: Partial<Pick<TTransaction, "reason" | "status">>,
   ) {
      return api
         .patch<TTransaction>(`/workspaces/${slug}/transactions/${id}`, data)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
   async createTransaction(
      slug: string,
      data: Pick<TTransaction, "amount" | "method" | "reason" | "type">,
   ) {
      return api
         .post<TTransaction>(`/workspaces/${slug}/transactions/`, data)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
}
